var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6793 7.90465C18.3627 8.58807 18.3627 9.69611 17.6793 10.3795L10.6793 17.3795C9.99591 18.0629 8.88788 18.0629 8.20446 17.3795L4.70446 13.8795C4.02104 13.1961 4.02104 12.0881 4.70446 11.4047C5.38788 10.7212 6.49591 10.7212 7.17933 11.4047L9.4419 13.6672L15.2045 7.90465C15.8879 7.22124 16.9959 7.22124 17.6793 7.90465Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6793 24.238C18.3627 24.9214 18.3627 26.0294 17.6793 26.7129L10.6793 33.7129C9.99591 34.3963 8.88788 34.3963 8.20446 33.7129L4.70446 30.2129C4.02104 29.5294 4.02104 28.4214 4.70446 27.738C5.38788 27.0546 6.49591 27.0546 7.17933 27.738L9.4419 30.0006L15.2045 24.238C15.8879 23.5546 16.9959 23.5546 17.6793 24.238Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6793 40.5713C18.3627 41.2547 18.3627 42.3628 17.6793 43.0462L10.6793 50.0462C9.99591 50.7296 8.88788 50.7296 8.20446 50.0462L4.70446 46.5462C4.02104 45.8628 4.02104 44.7547 4.70446 44.0713C5.38788 43.3879 6.49591 43.3879 7.17933 44.0713L9.4419 46.3339L15.2045 40.5713C15.8879 39.8879 16.9959 39.8879 17.6793 40.5713Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8586 28.9754C22.8586 28.0089 23.6421 27.2254 24.6086 27.2254H50.2752C51.2417 27.2254 52.0252 28.0089 52.0252 28.9754C52.0252 29.9419 51.2417 30.7254 50.2752 30.7254H24.6086C23.6421 30.7254 22.8586 29.9419 22.8586 28.9754Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8586 45.3088C22.8586 44.3423 23.6421 43.5588 24.6086 43.5588H50.2752C51.2417 43.5588 52.0252 44.3423 52.0252 45.3088C52.0252 46.2753 51.2417 47.0588 50.2752 47.0588H24.6086C23.6421 47.0588 22.8586 46.2753 22.8586 45.3088Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8586 12.6421C22.8586 11.6756 23.6421 10.8921 24.6086 10.8921H50.2752C51.2417 10.8921 52.0252 11.6756 52.0252 12.6421C52.0252 13.6086 51.2417 14.3921 50.2752 14.3921H24.6086C23.6421 14.3921 22.8586 13.6086 22.8586 12.6421Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.f368de54.svg";
export { ForwardRef as ReactComponent };